import React from 'react'
import '../reportTabs/ReportTabs.css'

const ReportTabs = () => {
  return (
    <div className='tabs-detail-sec report-tab'>
        <div className='report-box'>
            Report
      </div>
    </div>
  )
}

export default ReportTabs
